import React from "react";
import { OrganizationDto } from "../../../api/types/dtos";
import { getOrgInitials } from "../../../utils/getOrgInitials";
import styles from "./header.module.scss";

interface OrgLogoProps {
  organization: OrganizationDto | null;
}

const OrgLogo: React.FC<OrgLogoProps> = ({ organization }) => {
  if (!organization || !organization.name) return null;

  const logoUrl = organization.organizationLogo || organization.logo;

  if (logoUrl) {
    return (
      <div className={styles.orgLogo} style={{ flexShrink: 0, marginBottom: "8px" }}>
        <img
          src={logoUrl}
          alt={`${organization.name} logo`}
          className={styles.orgLogoImage}
        />
      </div>
    );
  }

  return (
    <div className={styles.orgLogo} style={{ flexShrink: 0, marginBottom: "8px" }}>
      <div className={styles.orgInitials}>{getOrgInitials(organization.name)}</div>
    </div>
  );
};

export default OrgLogo;
